import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { IBetslipState } from '../../../base/store/state';
import { BetslipError } from '../errors/betslip-error';
import { IBetslipErrorsState } from '../state';
import { BetslipValidationService } from './composition/betslip/betslip-validation.service';
import { PicksValidationService } from './composition/picks/picks-validation.service';
import { PreBetPlacementValidationService } from './composition/pre-bet-placement/pre-bet-placement-validation.service';
import { SlipsValidationService } from './composition/slips/slips-validation.service';
import { BetslipTypeValidationService } from './composition/types/betslip-type-validation.service';
import { ValidationSlipGeneratorService } from './generators/slips/validation-slip-generator.service';
import { extractPickErrors } from './utils/betslip-errors-state-utils';

@Injectable()
export default class BetslipErrorValidatorService {
    constructor(
        private pickValidator: PicksValidationService,
        private betslipValidationService: BetslipValidationService,
        private slipValidationService: SlipsValidationService,
        private typeValidationService: BetslipTypeValidationService,
        private preBetPlacementValidator: PreBetPlacementValidationService,
        private slipGenerator: ValidationSlipGeneratorService,
    ) {}

    validate$(betslipState: IBetslipState): Observable<IBetslipErrorsState> {
        const fullBetslip = this.slipGenerator.getBetslip(betslipState);

        const pickErrors = this.pickValidator.validatePicks(fullBetslip, betslipState);
        const betslipErrors = this.betslipValidationService.validate(fullBetslip, betslipState);
        const slipErrors$ = this.slipValidationService.validate$(fullBetslip, betslipState);
        const betslipTypeErrors = this.typeValidationService.validate(fullBetslip, betslipState);

        const [fullPickErrors, fullBetslipTypeErrors] = extractPickErrors(pickErrors, betslipTypeErrors);

        return slipErrors$.pipe(
            map((slipErrors) => {
                return {
                    betslipErrors,
                    pickErrors: fullPickErrors,
                    slipErrors,
                    betslipTypeErrors: fullBetslipTypeErrors,
                };
            }),
        );
    }

    validatePreBetPlacement(betslipState: IBetslipState): BetslipError[] {
        const fullBetslip = this.slipGenerator.getBetslip(betslipState);

        return this.betslipValidationService.validate(fullBetslip, betslipState).concat(this.preBetPlacementValidator.validatePreBetPlacement());
    }

    validateFullPreBetPlacement$(betslipState: IBetslipState): Observable<IBetslipErrorsState> {
        const fullBetslip = this.slipGenerator.getBetslip(betslipState);

        const betslipErrors = this.betslipValidationService
            .validate(fullBetslip, betslipState)
            .concat(this.preBetPlacementValidator.validatePreBetPlacement());

        const slipErrors$ = this.slipValidationService.validate$(fullBetslip, betslipState);
        const betslipTypeErrors = this.typeValidationService.validate(fullBetslip, betslipState);
        const pickErrors = this.pickValidator.validatePicks(fullBetslip, betslipState);

        return slipErrors$.pipe(
            map((slipErrors) => {
                return {
                    betslipErrors,
                    pickErrors,
                    slipErrors,
                    betslipTypeErrors,
                };
            }),
        );
    }
}
